var map = {
	"./icons/Cross.svg": 4,
	"./icons/Editor.svg": 5,
	"./icons/Lettering.svg": 6,
	"./icons/LogoColor.svg": 7,
	"./icons/Maintenance.svg": 8,
	"./icons/NotFound.svg": 9,
	"./icons/QuestionMark.svg": 10,
	"./icons/SadFaceError.svg": 11,
	"./icons/arrow-right-16.svg": 12,
	"./icons/clock.svg": 13,
	"./icons/locked-project-75.svg": 14
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;